import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { SUGGESTION_MODAL } from "@/constants/testIds";

export const SuggestionModal = ({ open, onOpenChange }) => {
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!message.trim()) {
      toast.error("Please write your suggestion.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/suggestions", { name: name.trim() || "Anonymous", message });
      toast.success("Thanks! We appreciate your suggestion.");
      setName("");
      setMessage("");
      onOpenChange(false);
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={SUGGESTION_MODAL.dialog} className="max-w-md rounded-[2rem]">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-bold text-[#0F2520]">Got a Suggestion?</DialogTitle>
          <DialogDescription className="font-light text-[#0F2520]/70">
            Help us improve Raijada Dog Kennel. Name is optional.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2">
          <Input
            data-testid={SUGGESTION_MODAL.nameInput}
            placeholder="Your Name (optional)"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="h-12 rounded-xl"
          />
          <Textarea
            data-testid={SUGGESTION_MODAL.messageInput}
            placeholder="Your suggestion..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="rounded-xl min-h-[100px]"
          />
          <Button
            data-testid={SUGGESTION_MODAL.submitBtn}
            type="submit"
            disabled={loading}
            className="w-full h-12 rounded-full bg-[#0F2520] hover:bg-[#D97736] text-white font-semibold"
          >
            {loading ? "Submitting..." : "Send Suggestion"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
